export * from './smartenv.classes.smartenv.js';
export type { TBrowserPlatform, TRuntimeTarget, TRuntimeType } from './interfaces/index.js';
